import { roundTo100Percent } from "./percentage-calculation";

const testCases = [
    {
        message: "should return empty array if input is empty",
        inputValues: [],
        expected: []
    },
    {
        message: "should work with equal distribution",
        inputValues: [25, 25, 25, 25],
        expected: [0.25, 0.25, 0.25, 0.25]
    },
    {
        message: "should work with a single item",
        inputValues: [50],
        expected: [1]
    },
    {
        message: "should work with multiple items not 100",
        inputValues: [50, 150, 200],
        expected: [0.125, 0.375, 0.5]
    },
    {
        message: "should work with real example values",
        inputValues: [58.42250000000001, 104.675, 4.755833333333333, 0.030000000000000002],
        expected: [0.348, 0.624, 0.028, 0]
    },
    {
        message: "should work with random example values",
        inputValues: [36.384, 37.479, 26.137],
        expected: [0.364, 0.375, 0.261]
    },
    {
        message: "should work with random example values",
        inputValues: [36.384, 37.479, 26.137],
        expected: [0.364, 0.375, 0.261]
    },
    {
        message: "should work with duplicate values",
        inputValues: [14400000, 7200000, 21600000, 7200000, 36000000],
        expected: [0.167, 0.083, 0.25, 0.083, 0.417]
    },
    {
        message: "should work for floating points precision example values",
        inputValues: [12.5, 18.75, 68.75],
        expected: [0.125, 0.188, 0.687]
    },
    {
        message: "should work for example values with an unrepresentable floating point sum",
        inputValues: [0, 54, 0, 0, 9, 18, 9],
        expected: [0, 0.6, 0, 0, 0.1, 0.2, 0.1]
    }
];

describe("round percentages to 100", function () {
    it(`should return NaN invalid places parameters`, function () {
        const output = roundTo100Percent([1, 2, 3], 0.5);
        expect(output.map((p) => p.percentageRounded)).toEqual([NaN, NaN, NaN]);
    });

    it(`should return NaN for invalid values`, function () {
        const output = roundTo100Percent([1, NaN, 3], 1);
        expect(output.map((p) => p.percentageRounded)).toEqual([NaN, NaN, NaN]);
    });

    it(`should return floor with one decimal if places parameter is undefined`, function () {
        const output = roundTo100Percent([1, 1, 3], undefined);
        expect(output.map((p) => p.percentageRounded)).toEqual([0.2, 0.2, 0.6]);
    });

    testCases.forEach(function ({ message, inputValues, expected }) {
        it(message || `should produce 1 for the pecentages of input ${inputValues.join(",")}`, function () {
            const output = roundTo100Percent(inputValues);
            expect(output.map((p) => p.percentageRounded)).toEqual(expected);
            if (output.length > 0) {
                expect(output.reduce((prev, curr) => prev + curr.percentageRounded, 0)).toBeCloseTo(1, 3);
            }
        });
    });
});
